import { useMemo } from 'react';

import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';

import { OptionsListItemTypeEnum } from '../../../../single-select/types';
import CorrectAnswers from '../../../QuestionReview/CorrectAnswers';
import { getFtbResponseType } from '../../../utils';
import FtbPlayerContainer from '../FtbPlayerContainer';
import { ftbQuestionPlayerStyles } from '../FtbPlayerContainer/styles';
import FtbBlank from './components/FtbBlank';
import { DropdownPlayerProps } from './types';

const DropdownPlayer: React.FC<DropdownPlayerProps> = (props) => {
  const {
    ftbComponents,
    onChange,
    ftbResponse,
    globalDistractedOptions,
    isQuestionSubmitted,
    correctFtbAnswers,
  } = props;

  const correctAnswerCount = useMemo(
    () =>
      ftbComponents.filter(
        (ftbComponent) =>
          ftbComponent.isBlank &&
          getFtbResponseType({ ftbComponent, correctFtbAnswers, ftbResponse }) ===
            OptionsListItemTypeEnum.Correct,
      ).length,
    [correctFtbAnswers, ftbComponents, ftbResponse],
  );
  const showCorrectAnswers =
    isQuestionSubmitted && correctFtbAnswers && correctFtbAnswers.length !== correctAnswerCount;

  const renderContent = (index: number) => {
    const ftbComponent = ftbComponents[index];
    if (ftbComponent.isBlank) {
      return (
        <FtbBlank
          key={ftbComponent.id}
          correctFtbAnswers={correctFtbAnswers}
          ftbComponent={ftbComponent}
          ftbResponse={ftbResponse}
          globalDistractedOptions={globalDistractedOptions}
          isQuestionSubmitted={isQuestionSubmitted}
          onChange={onChange}
        />
      );
    } else if (!ftbComponent.isBlank) {
      return (
        <Box key={ftbComponent.id} className="me-16 xs:mb-20 xs:me-12" component="span">
          <Typography className={cn('me-0', ftbQuestionPlayerStyles)} color="text-text-paragraph">
            {ftbComponent.text}
          </Typography>
        </Box>
      );
    }
  };

  return (
    <>
      <FtbPlayerContainer>
        {ftbComponents.map((_, index) => renderContent(index))}
      </FtbPlayerContainer>
      {showCorrectAnswers ? (
        <CorrectAnswers
          className="mt-32"
          correctFtbAnswers={correctFtbAnswers}
          ftbComponents={ftbComponents}
        />
      ) : null}
    </>
  );
};

export default DropdownPlayer;
